// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__107XX","content":"Consent_content__1-ODG","footer":"Consent_footer__17s_W"};